import r from "./usePaginatedRecords.js";
import { PaginationType as a } from "../types.js";
const i = (o) => r({
  ...o,
  pagination: a.CURSOR
});
export {
  i as default
};
